import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import PersonCounter from "../../../../../../../../others/person-counter/index.js";
import usePanelAccommodationPerson from "../../hooks/usePanelAccommodationPerson.js";
const PanelAccommodationPersonMobile = ({ roomIndex , personIndex , person , disableIncrement =false , disableAges =false  })=>{
    const { people , onValueChange , onSelectOption  } = usePanelAccommodationPerson(roomIndex, personIndex);
    const { personsLabel , optionsPersonLabel , options , personDescription , labelForEachOption , min , max  } = people[personIndex];
    const select = useMemo(()=>{
        if (disableAges) return;
        return {
            label: optionsPersonLabel,
            options,
            onChange: onSelectOption
        };
    }, [
        disableAges,
        onSelectOption,
        options,
        optionsPersonLabel
    ]);
    return /*#__PURE__*/ _jsx(PersonCounter, {
        label: personsLabel,
        description: personDescription,
        value: person.value,
        min: min,
        max: max,
        onChange: onValueChange,
        selectedOptions: !disableAges ? person.selectedOptions : undefined,
        labelForEachOption: labelForEachOption,
        select: select,
        disableIncrement: disableIncrement
    });
};
export default PanelAccommodationPersonMobile;

//# sourceMappingURL=index.js.map